OrNode = require('sma.applicant/surveys/logic.coffee').OrNode
PredicateNode = require('sma.applicant/surveys/logic.coffee').PredicateNode
BranchingRule = require('sma.applicant/surveys/logic.coffee').BranchingRule
DisableAction = require('sma.applicant/surveys/logic.coffee').DisableAction
InvalidAction = require('sma.applicant/surveys/logic.coffee').InvalidAction
SingleChoiceVariable = require('sma.applicant/surveys/variables.coffee').SingleChoiceVariable
MultipleChoiceVariable = require('sma.applicant/surveys/variables.coffee').MultipleChoiceVariable
BooleanVariable = require('sma.applicant/surveys/variables.coffee').BooleanVariable
HiddenVariable = require('sma.applicant/surveys/variables.coffee').HiddenVariable
Variable = require('sma.applicant/surveys/variables.coffee').Variable
DateTimeVariable = require('sma.applicant/surveys/variables.coffee').DateTimeVariable

class Question extends Backbone.Model
	@TYPES: {}
	@type: 'question'

	@create: (info, options) ->
		cls = @TYPES[info.idname ? info.type] ? this

		return new cls cls.parse(info), options

	@parse: (info) ->
		id: info.id
		name: info.name
		title: trans.make info.title
		description: trans.make info.description if info.description?

		appendToPrevious: info.appendToPrevious or undefined
		displayInline: info.display_inline or undefined
		questionWidth: if info.width? and info.width < 100 then info.width else undefined

	escapedId: ->
		### Returns this question's identifier suitable for use in a jQuery selector. ###
		@id.replace /([\.:])/g, "\\$1"

	name: (suffix = '') -> if @get('name') then @get('name') + suffix else undefined

	variables: -> {}

	validateResponse: (response) ->

	dynamics: ->

	render: ->
		$('<div/>')
			.attr('id', "x_#{@id}")
			.addClass("question question-#{@id} question-#{@constructor.type}")
			.toggleClass("append-to-previous", !!@get('appendToPrevious'))
			.toggleClass("question-inline", !!@get('displayInline'))
			.toggleClass("force-unique", !!@get('unique') or @ instanceof Question.Ranking)
			.toggleClass("appearance-#{@get('appearance')}", !!@get('appearance'))
			.css('width', if @get('questionWidth') then "#{@get('questionWidth')}%" else '')
			.append(@renderHeader(), $('<div class="question-body"/>').append(@renderContents()))

	renderHeader: ->
		$('<div class="question-header"/>').append(
			$('<h2 class="question-title"/>').html(Survey.pipe @get('title').toString()),
			Survey.pipe (@get('description') ? '').toString()
		)

	renderContents: ->
		return CoffeeKup.render(@template, context: this) if @template?

		vars = @variables()

		return vars[''].render() if '' of vars

	onSurveyBuilt: (survey) ->

	setupElement: (el, handler) -> el

	replacePipedString: (str) ->
		vars = survey.variablesByName()
		ids = survey.variables()
		piped = (value) ->
			if value == 'metas.weighted_score'
				@response.weightedScore
			else if piped[value]?
				piped[value]
			else
				source = vars[value] ? ids[value]
				if source?
					source.getPipedValue(handler.response.values[source.id])
		if str.match(/\{\{\s*([\w\-\.]+)\s*\}\}/g) then piped(str.replace /\{\{\s*([\w\-\.]+)\s*\}\}/g, "$1") else str

class Question.SectionSeparator extends Question
	@type: 'section-separator'

class Question.JavaScript extends Question
	@type: 'javascript'

	render: ->
		$('<script type="text/javascript"/>').append(
			"setTimeout(function(){" + Survey.pipe (@get('description') ? '').toString() + "}, 0);")

class Question.Hidden extends Question
	@type: 'hidden-field'

	@parse: (info) ->
		initialValue = info.children?[0]?.initialValue
		_.extend Question.parse(info),
			initialValue: initialValue

	variables: ->
		'': new HiddenVariable
			id: @id
			title: @get('title')
			name: @get('name')
			initialValue: @get('initialValue')

class Question.FileUpload extends Question.Hidden
	@type: 'file-field'

	template: ->
		env = detect()
		if cordova? and camera?
			div class: 'camera', ->
				input id: 'id_' + @id, type: 'hidden', name: @id
				label class: 'no-picture', ->
					text 'choose a picture'
				div class: 'button delete', onclick: 'camera(this.parentNode)'
				div class: 'button library', onclick: 'camera(this.parentNode, navigator.camera.PictureSourceType.PHOTOLIBRARY)'
				div class: 'button cam',  onclick: 'camera(this.parentNode, navigator.camera.PictureSourceType.CAMERA)'
		else
			div class: 'warning', ->
				text 'File upload is not supported'



class Question.TextResponse extends Question
	@type: 'text-response'

	@parse: (info) ->
		rows = info.children?[0]?.rows ? info.rows
		columns = info.children?[0]?.cols ? info.cols
		required = info.children?[0]?.required ? info.required
		appearance = info.children?[0]?.appearance ? info.appearance
		validation = info.children?[0]?.validation ? info.validation
		initialValue = info.children?[0]?.initialValue

		_.extend Question.parse(info),
			appearance: appearance
			rows: rows
			columns: columns
			required: required
			validation: validation
			initialValue: initialValue

	variables: ->
		'': new StringVariable
			id: @id
			title: @get('title')
			name: @get('name')
			appearance: @get('appearance')
			rows: @get('rows')
			columns: @get('columns')
			required: @get('required')
			validation: @get('validation')
			initialValue: @get('initialValue')

	getExtraction: (response, options={}) ->
		result = []

		number_of_loops = if response? then parseInt(response.values[@id], 10) else 10
		if not number_of_loops? or number_of_loops < 0
			number_of_loops = 1

		offset = number_of_loops + 1
		while (offset -= 1)
			j = Math.abs(number_of_loops - offset) + 1
			result.push new Choice j - 1,
				label: trans.make j.toString()

		return result


class Question.Slider extends Question.TextResponse
	@type: 'slider'

	variables: ->
		'': new StringVariable
			id: @id
			title: @get('title')
			name: @get('name')
			initialValue: @get('initialValue')
			required: @get('required')

	@parse: (info) ->

		initialValue = (info.children?[0]?.initialValue)
		leftLabel =  trans.make info.children?[0]?.leftLabel
		rightLabel = trans.make info.children?[0]?.rightLabel
		minimumValue = (info.children?[0]?.minimumValue)
		maximumValue = (info.children?[0]?.maximumValue)
		stepSize = info.children?[0]?.stepSize
		required = info.children?[0]?.required

		initialValue = (trans.make initialValue).toString()

		_.extend Question.parse(info),
			initialValue: initialValue
			leftLabel: leftLabel
			rightLabel: rightLabel
			minimumValue: minimumValue || 0
			maximumValue: maximumValue || 100
			stepSize: stepSize
			required: required


	template: ->
		text """
	<div class="slider_question">
		<span class="minimumValue hidden">#{@attributes.minimumValue}</span>
		<span class="maximumValue hidden">#{@attributes.maximumValue}</span>
		<span class="stepSize hidden">#{@attributes.stepSize}</span>
		<span class="initialValue hidden">#{@attributes.initialValue}</span>
	</div>

	<div class="labels">
	<div class="label left">#{@attributes.leftLabel.toString()}</div>
	<div class="label right">#{@attributes.rightLabel.toString()}</div>
	</div>"""

		variable = @variables()['']
		text variable.render()



class Question._ChoiceBase extends Question
	@parse: (info) ->

		choices = info.children?[0]?.choices ? info.choices ? []

		required = info.children?[0]?.required ? info.required
		randomize = info.children?[0]?.randomize ? info.randomize
		appearance = info.children?[0]?.choiceAppearance ? info.choiceAppearance
		simpleBranching = info.children?[0]?.branch ? info.simpleBranching
		initialValue = info.children?[0]?.initialValue
		alphabetize = info.children?[0]?.alphabetize

		_.extend Question.parse(info),
			choices: Choice.makeList choices
			required: required
			randomize: randomize
			appearance: appearance
			simpleBranching: simpleBranching
			initialValue: initialValue
			alphabetize: alphabetize



class Question._Choice extends Question._ChoiceBase
	@parse: (info) ->
		extraction = info.children?[0]?.extraction ? info.extraction

		_.extend Question._ChoiceBase.parse(info),
			extraction: if extraction? then new Extraction extraction else undefined

	onSurveyBuilt: (survey) ->
		if (extraction = @get('extraction'))?
			extraction.resolve survey

	setupElement: (el, handler) ->
		if (extraction = @get('extraction'))?
			enabled = extraction.evaluate(handler)

			el
				.find('[data-extraction]')
				.filter(-> not enabled? or $(this).data('extraction') not of enabled)
				.remove()

		return el

class Question.MultipleChoice extends Question._Choice
	@type: 'single-choice'

	variables: ->
		choices = @get('choices')

		result =
			'': new SingleChoiceVariable
				id: @id
				title: @get('title')
				name: @get('name')
				choices: choices
				extraction: @get('extraction')
				required: @get('required')
				randomize: @get('randomize')
				appearance: @get('appearance')
				initialValue: @get('initialValue')

		for choice, i in choices
			choice.set variable: result['']
			if choice.get('other')
				result[i] = new StringVariable
					id: "#{@id}_other"
					title: @get('title')
					exportId: "#{@id}\\other"
					name: @name(".other")
					validation: choice.get('validation')
					required: choice.get('other_required')
					choice: choice
				choice.set other: result[i]

		return result

	getSimpleBranching: -> BranchingRule::parseSimple(this, @get('simpleBranching'))

class Question.Checkbox extends Question._Choice
	@type: 'multiple-choice'

	@parse: (info) ->

		restrictions =
			minChecked: info.children?[0]?.restrictions?.minChecked
			maxChecked: info.children?[0]?.restrictions?.maxChecked
			message: trans.make info.children?[0]?.err_msg if info.children?[0]?.err_msg?

		restrictions = undefined if not (restrictions.minChecked? or restrictions.maxChecked?)
		_.extend Question._Choice.parse(info),
			restrictions: restrictions

	variables: ->
		choices = @get('choices')

		result =
			'': new MultipleChoiceVariable
				id: @id
				title: @get('title')
				name: @get('name')
				choices: choices
				extraction: @get('extraction')
				required: @get('required')
				randomize: @get('randomize')
				appearance: @get('appearance')
				restrictions: @get('restrictions')

		for choice, i in choices

			choice.set variable: result['']
			if choice.get('other')
				result[i] = new StringVariable
					id: "#{@id}_#{choice.get('id')}_other"
					title: @get('title')
					exportId: "#{@id}\\#{choice.get('id')}\\text"
					name: @name(".other.#{choice.get('id')}")
					validation: choice.get('validation')
					required: choice.get('other_required')
					choice: choice
				choice.set other: result[i]

		return result

	getExtraction: (response, options={}) ->
		return @get('choices') if not response?

		_.filter @get('choices'), (choice) =>
			return (choice.id in response.values[@id]) == !options.inverted

class Question.Dropdown extends Question._Choice
	@type: 'dropdown-choice'

	variables: ->
		'': new SingleChoiceVariable
			id: @id
			title: @get('title')
			name: @get('name')
			appearance: 'dropdown'
			choices: @get('choices')
			extraction: @get('extraction')
			required: @get('required')
			randomize: @get('randomize')
			initialValue: @get('initialValue')
			alphabetize: @get('alphabetize')


	getSimpleBranching: -> BranchingRule::parseSimple(this, @get('simpleBranching'))

class Question.Drilldown extends Question._ChoiceBase
	@type: 'drill-down'

	@parse: (info) ->
		appearance = info.children?[0]?.display ? info.appearance ? 'default'
		categories = Choice.makeList(info.children?[0]?.categories ? info.categories ? [])

		# only apply when displayed as a likert question
		leftLabel = info.children?[0]?.leftLabel ? info.leftLabel ? ''
		rightLabel = info.children?[0]?.rightLabel ? info.rightLabel ? ''
		flipOrder = info.children?[0]?.flipOrder
		showCategoryLabels = info.children?[0]?.showCatLabels ? info.showCategoryLabels

		# rewrite individual choice ids
		i = 0
		choices = []
		for category in categories
			for choice in category.get('choices')
				choice.id = i++
				choices.push choice

		_.extend Question._ChoiceBase.parse(info),
			appearance: appearance
			categories: categories
			choices: choices
			leftLabel: trans.make leftLabel
			rightLabel: trans.make rightLabel
			flipOrder: flipOrder
			showCategoryLabels: showCategoryLabels

	leftLabel: -> @get('leftLabel')?.toString()
	rightLabel: -> @get('rightLabel')?.toString()

	variables: ->
		'': new SingleChoiceVariable
			id: @id
			title: @get('title')
			name: @get('name')
			appearance: if @get('appearance') == 'dropdown' then 'dropdown' else 'drilldown'
			categories: @get('categories')
			choices: @get('choices')
			required: @get('required')

	getSimpleBranching: -> BranchingRule::parseSimple(this, @get('simpleBranching'))

	template: ->
		variable = @variables()['']

		if @get('appearance') == 'likert'
			flipOrder = @get('flipOrder')

			categories = @get('categories')
			categories = _.toArray(categories).reverse() if flipOrder

			choices = variable.choices()
			choices = _.toArray(choices).reverse() if flipOrder

			table class: "grouped-table", ->
				thead ->
					if @get('showCategoryLabels')
						tr ->
							th ""
							for category in categories
								th class: "choice", colspan: category.get('choices').length, -> category.label()
							th ""
					tr ->
						th ""
						for choice in choices
							th class: "choice", align: "center", -> choice.label()
						th ""
				tbody ->
					tr ->
						th (if flipOrder then @rightLabel() else @leftLabel())
						for choice in choices
							td align: "center", ->
								input id: "id_#{@id}_#{choice.id}", name: "#{@id}", type: 'radio', value: choice.id
						th (if flipOrder then @leftLabel() else @rightLabel())

		else
			text variable.render()


class Question.NetPromoter extends Question.Drilldown
	@type: 'net-promoter'

	@parse: (info) ->
		_.extend Question.Drilldown.parse(info)

class Question.DateTime extends Question
	@type: 'datetime'

	@parse: (info) ->

		timezone = info.children?[0]?.timezone ? info.timezone

		format = parseInt(info.children?[0]?.dateFormat ? info.dateFormat ? "0", 10)
		format = ['datetime', 'date', 'time', 'monthday', 'yearmonth'][format] ? 'datetime'
		format = 'datetimetz' if format == 'datetime' and timezone

		showNowButton = format in ['datetime', 'datetimetz', 'time'] and (info.showNowButton ? info.children?[0]?.showNowButton ? false)

		_.extend Question.parse(info),
			format: format
			showNowButton: showNowButton

	variables: ->
		'': new DateTimeVariable
			id: @id
			title: @get('title')
			name: @get('name')
			required: @get('required')
			format: @get('format')
			showNowButton: @get('showNowButton')


class Question._Grid extends Question
	@parse: (info) ->
		_.extend Question.parse(info),
			children: Choice.makeList info.children
			randomize: info.randomize or undefined
			unique: info.unique or undefined
			firstColSize: Number info.questionSize or 30

	variables: ->
		result = {}
		for child, i in @get('children')
			result[i] = @createVariable i, child
			if @get('extraction')
				result[i].set('label',@get('extraction').labelForChoice i)
			# Extraction needs to have access to the actual index of the element
			# (id includes the question id as well). Set it here for any grid type
			# questions.
			result[i].index = i

		result

	variablesDisplay: ->
		variables = _(@variables()).values()
		variables = _(variables).shuffled() if @get('randomize')
		variables

	validateResponse: (response) ->

		if @get('unique')
			values = _(response.values[variable.id]? for id, variable of @variables())
				.select (el) -> el?.length

			if _(values).uniq().length != values.length
				throw new UniqueError

	renderContents: ->
		return CoffeeKup.render(@template, context: this) if @template?

	# FIXME: onSurveyBuilt and setupElement are the same as for _Choice questions.
	onSurveyBuilt: (survey) ->
		if (extraction = @get('extraction'))?
			extraction.resolve survey

	setupElement: (el, handler) ->
		if (extraction = @get('extraction'))?
			enabled = extraction.evaluate(handler)
			el
				.find('[data-extraction]')
				.filter(-> not enabled? or $(this).data('extraction') not of enabled)
				.remove()

		return el

class Question._ChoiceGrid extends Question._Grid
	variableClass: SingleChoiceVariable
	hasRightLabels: false

	@parse: (info) ->

		choices = info.choices ? info.children?[0]?.choices ? []
		extraction = info.extraction

		_.extend Question._Grid.parse(info),
			choices: Choice.makeList choices
			children: Choice.makeList info.children
			extraction: if extraction? then new Extraction extraction else undefined

			# deprecated
			showBorders: info.showBorders or undefined


	createVariable: (i, info) ->
		new @variableClass
			id: "#{@id}_#{i}"
			title: "#{@get('title')} | #{info.get('label')}"
			name: "#{@get('name')}.#{i}" if @get('name')
			label: info.get('label')
			rightLabel: info.get('rightLabel')
			choices: @get('choices')
			required: info.get('required')

	template: ->
		choices = @get('choices')
		edgeColSize = Number @get('firstColSize') or 30

		choiceColSize = (100 - edgeColSize) / choices.length
		edgeColSize = if @hasRightLabels then edgeColSize / 2 else edgeColSize

		tableClasses = 'grouped-table'
		tableClasses += ' show-borders' if @get('showBorders')

		div class: 'error-placeholder', id: "error_#{@id}"
		div class: 'grouped-table-container', -> table class: tableClasses, ->
			thead -> tr ->
				th width: "#{ edgeColSize.toFixed 0 }%", ->
				for choice in choices
					th width: "#{ choiceColSize.toFixed 0 }%", -> choice.label()
				if @hasRightLabels
					th width: "#{ edgeColSize.toFixed 0 }%", ->
			tbody ->
				for row in @variablesDisplay()
					attrs = {}
					if @get('extraction')
						attrs['data-extraction'] = row.index
					tr attrs, class: 'error-row-container', ->
						td class: 'error-placeholder', id: "error_#{row.id}", colspan: choices.length + 1
					tr attrs, class: "variable", id: "x_#{row.id}", ->
						th -> label for: "id_#{row.id}_0", -> Survey.pipe row.label()
						for choice in choices
							td -> input type: @variableClass::inputType, name: row.id, value: choice.id, id: "id_#{row.id}_#{choice.id}"
						if @hasRightLabels
							th -> label for: "id_#{row.id}_0", -> row.rightLabel()

	getExtraction: (response, options={}) ->
		result = []
		for i, variable of @variables()
			if response? and  not ((if response.values[variable.id]!=undefined and response.values[variable.id]!="" then response.values[variable.id] else -1) in _.values(options?.choices))
				continue

			result.push new Choice i,
				label: variable.label()

		return result

class Question.MultipleChoiceGrid extends Question._ChoiceGrid
	@type: 'single-choice-grid'
	
class Question.Ranking extends Question.MultipleChoiceGrid
	@type: 'ranking'

	@parse: (info) ->
		_.extend Question.MultipleChoiceGrid.parse(info),
			required: info.required ? false

	createVariable: (i,info) ->
		_.extend (super i, info),
			required: false

	validateResponse: (r) ->
		super r
		if @get('required')
			remaining = _.clone @attributes.choices
			for i,v of @variables()
				resp = r.values[v.id]
				if resp?
					remaining = _.reject remaining, (x) -> x.id is resp
			throw new RequiredError if remaining.length

	template: ->
		if navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/)
			choices = @get('choices')
			tableClasses = 'grouped-table'
			tableClasses += ' show-borders' if @get('showBorders')
			div class: 'error-placeholder', id: "error_#{@id}"
			div class: 'grouped-table-container', -> table class: tableClasses, ->
				thead -> tr ->
					th ->
					for choice in choices
						th -> choice.label()
					if @hasRightLabels
						th ->
				tbody ->
					for row in @variablesDisplay()
						attrs = {}
						if @get('extraction')
							attrs['data-extraction'] = row.index

						tr attrs, class: 'error-row-container', ->
							td class: 'error-placeholder', id: "error_#{row.id}", colspan: choices.length + 1
						tr attrs, class: "variable", id: "x_#{row.id}", ->
							th -> label for: "id_#{row.id}_0", -> row.label()
							for choice in choices
								td -> input type: @variableClass::inputType, name: row.id, value: choice.id, id: "id_#{row.id}_#{choice.id}"
							if @hasRightLabels
								th -> label for: "id_#{row.id}_0", -> row.rightLabel()
		else
			choices = @get('choices')
			vars = @variablesDisplay()
			div class: 'error-placeholder', id: "error_#{@id}"
			div class: 'ranking-question', ->
				table class: 'var-choice-table', ->
					tr ->
						td ->
							div class: 'rank-variable-bin', style: "width:210px", ->
								for row in vars
									attrs = {}
									if @get('extraction')
										attrs['data-extraction'] = row.index
									div attrs, class: 'draggable-rank-variable-box', ->
										span class: 'variable_index', style: 'display:none;', -> row.id
										div class: 'draggable-rank-variable-text', -> row.label()
						td class: 'rank-middle-cell', ->
							span class: 'drag-icon'
						td ->
							index = 0
							div class: 'rank-choice-bin', style: "width:210px", ->
								for choice in choices
									div class: 'droppable-rank-variable-box', ->
										span class: 'rank_index', style: 'display:none;', -> "#{index++}"
										div class: 'droppable-rank-variable-text', -> choice.label()

				div id: 'original-question', style: 'display:none;', ->
					ul class: 'matrix textgridmatrix', style:'width: 100%;', ->
						for row in vars
							attrs = {}
							if @get('extraction')
								attrs['data-extraction'] = row.index
							var_style = if row.hidden then 'display:none;' else ''
							li attrs, class: 'variable', id:"x#{row.id}", style: var_style, ->
								row.render()



class Question.TextResponseGrid extends Question._Grid
	@type: 'text-response-grid'

	@parse: (info) ->
		extraction = info.extraction
		_.extend Question._Grid.parse(info),
			sum: if info.sum? then info.sum else undefined
			sumLabel: trans.make info.sum_label
			extraction: if extraction? then new Extraction extraction else undefined

	createVariable: (i, info) ->
		rows = info.get('rows')
		columns = info.get('columns')
		appearance = info.get('appearance')
		validation = info.get('validation')
		initialValue = info.get('initialValue')

		new StringVariable
			id: "#{@id}_#{i}"
			title: "#{@get('title')} | #{info.get('label')}"
			name: "#{@get('name')}.#{i}" if @get('name')
			label: info.label()
			required: info.get('required')
			rows: rows
			columns: columns
			appearance: appearance
			validation: validation
			initialValue: initialValue

	getExtraction: (response, options={}) ->
		result = []

		for i, variable of @variables()
			if response? and not response.values[variable.id]
				continue

			result.push new Choice i,
				label: if response? then response.values[variable.id] else variable.label()

		return result

	validateResponse: (response) ->
		super(response)

		if @get('unique')
			values = _(response.values[variable.id].trim() ? 'N/A' for id, variable of @variables()).toArray()
			while values.length
				v = values.pop()
				if not (v is '')
					for vx in values
						throw new UniqueError if v is vx

		if @get('sum')
			total = 0
			values = _(response.values[variable.id] ? 'N/A' for id, variable of @variables())
    			.select (el) -> el?.match(/^(\d+)|(\d*\.\d+)$/)

			_(values).each (el) ->
				total += if el.indexOf('.') < 0 then parseInt(el, 10) else parseFloat(el)
			piped_sum = @replacePipedString @get('sum')
			if total != parseInt(piped_sum,10)
				throw new ValidationError @get('sumLabel').toString().replace('{x}', piped_sum).replace('{y}', total)

	template: ->
		div class: 'error-placeholder', id: "error_#{@id}"

		ul class: 'matrix' + (if @get('sum')? then ' sum-inputs' else ''), ->
			for row in @variablesDisplay()
				attrs = {}
				if @get('extraction')
					attrs['data-extraction'] = row.index
				li attrs, class: 'variable', id: "x_#{row.id}", ->
					label class: 'control-label', for: "id_#{row.id}", -> row.label()
					div class: 'controls', -> row.render()
		if @get('sum')?
			span class: 'sum-label', 'data:sum': @get('sum'), 'data:label': @get('sumLabel')

class Question.DropdownGrid extends Question._ChoiceGrid
	@type: 'dropdown-grid'

	createVariable: (i, info) ->
		new SingleChoiceVariable
			id: "#{@id}_#{i}"
			title: "#{@get('title')} | #{info.get('label')}"
			name: "#{@get('name')}.#{i}" if @get('name')
			label: info.label()
			choices: @get('choices')
			appearance: 'dropdown'
			required: info.get('required')

	template: ->
		div class: 'error-placeholder', id: "error_#{@id}"
		ul class: 'matrix', ->
			for row in @variablesDisplay()
				li class: 'variable', id: "x_#{row.id}", ->
					label class: 'control-label', for: "id_#{row.id}", -> row.label()
					div class: 'controls', -> row.render()

class Question.Natrix extends Question._Grid
	@type: 'custom-grid'

	@parse: (info) ->
		_.extend Question.parse(info),
			children: info.children

	variables: -> Variable.makeList @id, @name(), @get('children'), @get('title')

	template: ->
		ul class: 'matrix', ->
			for row in @variablesDisplay()
				li class: 'variable', id: "x_#{row.id}", ->
					if row.type == 'single' and row.get('appearance') != 'dropdown'
						label class: 'control-label', for: "id_#{row.id}_0", -> row.label()
					else
						label class: 'control-label', for: "id_#{row.id}", -> row.label()
					div class: 'controls', -> row.render()

class Question.ThreeDGrid extends Question
	@type: 'threed-grid'

	@parse: (info) ->
		extraction = info.extraction
		columns = for child in info.children when child.row == 0
			id: child.column
			label: trans.make child.colname
			type: child.type
			choices: Choice.makeList child.choices if child.choices?
			appearance: switch child.type
				when 'single' then child.choiceAppearance
				when 'dropdown' then 'dropdown'
				else child.appearance
			rows: child.rows
			columns: child.cols
			validation: child.validation
			sum: if child.sum then parseInt(child.sum, 10) else undefined
			dynamics: child.dynamics
			initialValue: child.initialValue

		rows = for child in info.children when child.column == 0
			id: child.row
			label: trans.make child.label
			required: child.required

		return _.extend Question.parse(info),
			rows: rows
			columns: columns
			unique: info.unique or undefined
			sumLabel: info.sumLabel or undefined
			showNotUsed: info.showNotUsed or undefined
			notUsedText: if info.notUsedText? then trans.make info.notUsedText else undefined
			extraction: if extraction? then new Extraction extraction else undefined

			# deprecated
			showBorders: info.showBorders or undefined

	grouped: (column) -> column.type == 'single' and column.appearance == 'column'

	hasGroupedColumn: -> _(@get('columns')).any (el) => @grouped(el)

	requiresTotalRow: ->
		@get('sumLabel') and _(@get('columns')).any (el) -> el.sum?

	dynamics: ->
		rules = []

		if @get('showNotUsed')
			for row, j in @get('rows')
				variable = "#{@id}_#{row.id}_na"
				rules.push new BranchingRule(new PredicateNode(variable, 'yes'), new DisableAction("#{@id}[#{row.id}:]", variable))

		columns = @get('columns')
		variables = @variables()

		for column, i in columns
			continue if not column.dynamics?

			dynamics = column.dynamics

			variable = (row) -> variables["#{row.id}_#{column.id}"].id

			if column.type in ['boolean', 'checkbox']
				condition = (row) -> new PredicateNode(variable(row), 'yes')
			else if column.type in ['single', 'dropdown']
				condition = (row) -> new PredicateNode(variable(row), 'isoneof', value: dynamics.choices)
			else
				continue

			conditions = new OrNode(condition(row) for row in @get('rows'))

			for rule in dynamics.rules
				if rule.target == 'current-row'
					for row, j in @get('rows')
						rules.push new BranchingRule(condition(row), new DisableAction("#{@id}[#{row.id}:]", variable(row)))
				else
					rules.push new BranchingRule(conditions, new DisableAction(rule.target))

		rules

	variables: ->
		result = {}

		i = 0

		for row in @get('rows')
			if @get('showNotUsed')
				result["#{row.id}_na"] = new BooleanVariable
					id: "#{@id}_#{row.id}_na"
					appearance: 'checkbox'

			for column in @get('columns')
				attrs =
					id: "#{@id}_#{i}"
					title: "#{@get('title')} | #{row.label} | #{column.label}"
					name: "#{@get('name')}.#{row.id}.#{column.id}" if @get('name')
					choices: column.choices ? []
					appearance: column.appearance
					rows: column.rows
					columns: column.columns
					required: row.required
					validation: column.validation
					initialValue: column.initialValue
				i++

				result["#{row.id}_#{column.id}"] = new (switch column.type
					when 'checkbox', 'boolean' then BooleanVariable
					when 'string' then StringVariable
					when 'single', 'dropdown' then SingleChoiceVariable) attrs

		return result

	validateResponse: (response) ->
		variables = @variables()

		if @get('unique')
			values = _(response.values[variable.id]? for id, variable of variables)
				.select (el) -> el?.length

			if _(values).uniq().length != values.length
				throw new UniqueError

		for column in @get('columns')
			if column.sum
				total = 0

				values = _(response.values[variables["#{row.id}_#{column.id}"].id]? for row in @get('rows'))
					.select (el) -> el?.match(/^(\d+)|(\d*\.\d+)$/)

				_(values).each (el) ->
					total += if el.indexOf('.') < 0 then parseInt(el, 10) else parseFloat(el)

				if total != column.sum
					throw new ValidationError "The values in column \"#{column.label}\" must sum to #{column.sum} (currently #{total})."

	template: ->
		vars = @variables()

		hasGroupedColumn = @hasGroupedColumn()
		rowSpan = if hasGroupedColumn then 2 else 1

		tableClasses = 'grouped-table threed-matrix'
		tableClasses += ' show-borders' if @get('showBorders')

		div class: 'error-placeholder', id: "error_#{@id}"

		div class: 'grouped-table-container', -> table class: tableClasses, ->
			colgroup span: 1
			for column in @get('columns')
				if @grouped(column)
					colgroup span: column.choices.length
				else
					colgroup span: 1

			thead ->
				tr ->
					th rowspan: rowSpan, ->
					if @get('showNotUsed')
						th class: "x_#{@id}__na", -> (@get('notUsedText') ? "Not Used").toString()
					for column in @get('columns')
						if @grouped(column)
							th class: "x_#{@id}__#{column.id}", colspan: column.choices.length, -> column.label.toString()
						else
							th class: "x_#{@id}__#{column.id}", rowspan: rowSpan, -> column.label.toString()

				if hasGroupedColumn
					tr ->
						for column in @get('columns')
							if @grouped(column)
								for choice in column.choices
									th class: "x_#{@id}__#{column.id}__#{choice.id}", -> choice.label()
			tbody ->
				for row in @get('rows')
					attrs = {}
					if @get('extraction')
						attrs['data-extraction'] = row.id
					tr attrs, class: "x_#{@id}_#{row.id}", ->
						th -> label for: "id_#{vars[row.id + '_0'].id}", style: "width: 250px;", -> row.label.toString()
						if @get('showNotUsed')
							td class: "x_#{@id}__na", ->
								vars["#{row.id}_na"].render()
						for column in @get('columns')
							if @grouped(column)
								id = vars["#{row.id}_#{column.id}"].id
								for choice in column.choices
									td class: "x_#{@id}__#{column.id}__#{choice.id}", ->
										input type: 'radio', name: id, value: choice.id, id: "id_#{id}_#{choice.id}"
							else
								td class: "x_#{@id}__#{column.id}" + (if column.sum then ' sum-inputs' else ''), id: "x_#{@id}_#{row.id*@get('columns').length+column.id}", ->
									vars["#{row.id}_#{column.id}"].render()

			if @requiresTotalRow()
				tfoot ->
					tr ->
						th -> @get('sumLabel')
						for column in @get('columns')
							td colspan: (if @grouped(column) then column.choices.length else 1), ->
								if column.sum
									span class: 'sum-label', 'data:sum': @get('sum'), 'data:target': "x_#{@id}__#{column.id}"

	# FIXME: onSurveyBuilt and setupElement are the same as for _Choice questions.
	onSurveyBuilt: (survey) ->
		if (extraction = @get('extraction'))?
			extraction.resolve survey

	setupElement: (el, handler) ->
		if (extraction = @get('extraction'))?
			enabled = extraction.evaluate(handler)

			el
				.find('[data-extraction]')
				.filter(-> not enabled? or $(this).data('extraction') not of enabled)
				.remove()

		return el

class Question.Signature extends Question.Hidden
	@type: 'signature'

	template: ->
		div class: 'signature'
		html @variables()[''].render()
		a href: '#', style: "float:right", class: 'button reset-signature', -> span -> 'Clear'

for name, cls of Question
	Question.TYPES[cls.type] = cls if cls.type?


_.extend exports, {
	Question
}



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/surveys/questions.coffee